import { writable } from "svelte/store";
import { persist, createLocalStorage } from "@macfja/svelte-persistent-store"
import type { Id } from "@/api";

export let favoriteIds = persist(writable<Id[]>([]), createLocalStorage(), "Informatiktage.Favorites");
